import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Subject, combineLatest } from 'rxjs';
import { PreferenceService } from '../../../services/preference.service';
import { MessageService, SelectItem, TreeNode } from 'primeng/api';
import { PaymentDocumentPdfComponent } from '../document-pdf/document-pdf.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as fromFeature from '../../../my-features';
import { RegionService } from 'src/app/services/region.service';
import { CryptoService } from '../../../services/crypto.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UpdateInfoModel } from '../../../my-features/updateInfo/update-info.model';
import { ComfirmGenerateDocumentManuallyType, updateInfoType, monthMap, reportDataField, ChargeType, mspPaymentDocumentStatusNumber, PaymentTypeIndex } from '../../../shareModel';
import { takeUntil } from 'rxjs/operators';


@Component({
  standalone: false,
  selector: 'app-generate-document-manually',
  templateUrl: './generate-document-manually.component.html',
  styleUrls: ['./generate-document-manually.component.css']
})
export class GenerateDocumentManuallyComponent implements OnInit {
  @ViewChild(PaymentDocumentPdfComponent, { static: false }) childDialog: PaymentDocumentPdfComponent;
  private componentDestroyed = new Subject();
  deviceUsageTable_cols: any[] = [
    { field: 'Company', header: 'Company Name', width: '360', class: 'col-nowrap' },
    { field: '', header: 'Quantity (Last month)', width: '220', class: 'col-nowrap' },
    { field: '', header: 'Growth Amount', width: '220', class: 'col-nowrap' },
    { field: '', header: 'Quantity (This month)', width: '220', class: 'col-nowrap' },
    // { field: 'UnitPrice', header: 'Unit Price (USD/mon)', width: '220', class: 'col-nowrap' },
    // { field: 'Amount', header: 'Amount (USD)', width: '220', class: 'col-nowrap' },
  ];
  summaryTable_cols: any[] = [
    { field: 'Company', header: 'Model Name', width: '360', class: 'col-nowrap' },
    { field: '', header: 'Quantity (NPM)', width: '220', class: 'col-nowrap' },
    { field: '', header: 'Unit Price (USD)', width: '220', class: 'col-nowrap' },
    { field: '', header: 'Total Amount (USD)', width: '220', class: 'col-nowrap' },
  ];
  UpdateInfoParam = {} as UpdateInfoModel;
  datePickStart: Date;
  deviceUsageList: TreeNode[];
  summaryList: TreeNode[];
  deviceUsageTotal = {
    name: '',
    quantity: 0,
    last_quantity: 0,
    unitprice: 0,
    amount: 0,
  };
  summaryTotal = {
    name: '',
    quantity: 0,
    unitprice: 0,
    amount: 0,
  };
  docDetailInfo = {
    Company: '',
    DocNo: '',
    MonthYear: '',
    DocDate: '',
    MinCharge: 0,
    RegionName: '',
    Period: '',
  };
  getMspDocParam = {
    otp: '',
    RegionId: 0
  };
  dialogDocInput = {
    DocId: 0,
    UnitPrice: 0,
    Date: null,
    Month: 1,
    Year: 2024,
    IsDistributorAll: true,
    DocNo: '',
    DocDay: 0,
    EmailInfo: [],
    PaymentType: 0,
    Quantity: 0,
    IsFree: false,
    Type: 'Add',
    DocStatus: -1
  };
  dialogDocInputDisabled = {
    UnitPrice: false,
    Date: false,
    Month: false,
    Year: false,
    DocNo: false,
    PaymentType: false,
    Quantity: false,
    IsFree: false
  };
  sendDocButton: boolean;
  dialogVisibility = {
    confirm: false,
    sendPDF: false,
  };
  getMspDeviceUsageParam = {
    otp: '',
    RegionId: 0,
    UsageDate: '',
    UnitPrice: 0,
    IsDistributorAll: true,
    Quantity: 0,

  };
  docList_dic = {
    op_dic: [],
    invoice_dic: []
  };
  dialogDocInput_No: string;
  docMonthYearIsExist = true;
  monthOptions: SelectItem[] = [];
  yearOptions: SelectItem[] = [];
  isMspLoaded = false;
  show_Doc_Info = {
    BillingInfo: false,
    Summary: false,
    DeviceUsage: false
  };
  getMspRegionParam = {
    otp: '',
    RegionId: []
  };

  ReadRegionParam = {
    MspMainRegionId: 0,
    otp: ''
  };
  docType = 0; // 預設Invoice
  isDistributor = false;
  companyOptions = [];

  PaymentTypeOptions = [
    { label: 'Prepaid NPM ', value: 0 },
    { label: 'Monthly', value: 1 },
  ];
  docUnitPriceStatsh: number;
  docUnitPriceDisabled: boolean;
  ChargeType = ChargeType;
  PaymentTypeIndex = PaymentTypeIndex;
  PreviewSuccess = false;
  once_preview = false;

  constructor( private _location: Location, public preferenceService: PreferenceService, private store: Store<fromStore.State>,
    private ngxService: NgxUiLoaderService, private messageService: MessageService,
    private router: Router, private cryptoService: CryptoService, private route: ActivatedRoute, private regionService: RegionService ) {
    this.ngxService.start();
    const regionId = parseInt(this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('id')));
    if (regionId == null || regionId == undefined) {
      this.router.navigate(['/management/payment']);
    }

    const year = this.dialogDocInput.Year.toString();
    const month = this.dialogDocInput.Month.toString().padStart(2, '0');
    // const date = this.datePickStart.getDate().toString().padStart(2, '0');
    // 前一月份的1號
    const dateStr = `${year}-${month}-01`;
    // const dateStr = `${year}-${month}-${date}`;

    this.getMspDeviceUsageParam = {
      ...this.getMspDeviceUsageParam,
      UsageDate: dateStr,
    };
    this.getMspDocParam = {
      ...this.getMspDocParam,
      RegionId: regionId,
    };
    this.dialogDocInput.Date = dateStr;

    // Msp Data
    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getCurrentUser))
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getIsMspRes, getCurrentUserRes]) => {
      if (!this.isMspLoaded) {
        this.ngxService.start();
      }
      if ((getIsMspRes !== undefined && getIsMspRes !== null) && (getCurrentUserRes !== undefined && getCurrentUserRes !== null)) {
        // Get IsMsp
        this.isMspLoaded = true;
        if (getIsMspRes && getCurrentUserRes.authority === 1) {
          this.router.navigate(['/dashboard']);
        } else {
          // this.store.dispatch(new fromFeature.ReadMspPaymentDocumentList(this.getMspDocParam));

          const isSystemAdmin = getCurrentUserRes.authority === 2;
          const isAdmin = getCurrentUserRes.authority === 1;
          const isMsp = getIsMspRes;
          this.getMspRegionParam = {
            ...this.getMspRegionParam,
            RegionId: (!isSystemAdmin && isAdmin && !isMsp)
              ? [getCurrentUserRes.RegionId]
              : [],
          };
          this.getMspDeviceUsageParam = {
            ...this.getMspDeviceUsageParam,
            RegionId: regionId,
          };
          this.ReadRegionParam = {
            ...this.ReadRegionParam,
            MspMainRegionId: regionId,
          };
          this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getMspRegionParam }));
          // this.store.dispatch(new fromFeature.ReadMspDeviceUsageList(this.getMspDeviceUsageParam));
          this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
        }
      }
    });

    // Get Device Usage List
    this.store.select(fromStore.getMspDeviceUsageList(regionId)).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.ngxService.start();
      if (res !== undefined && res.deviceUsage !== undefined && this.dialogDocInput.DocNo ) {
        if (res.deviceUsage.length > 0 && res.region_dic.length > 0) {
          // 代表沒有比對到任何Usage
          this.summaryList = [];
          this.deviceUsageList = [];
          res.deviceUsage.map((d) => {
            if (d.data !== undefined && d.name == undefined ) {
              this.deviceUsageList.push({
                data: { ...d.data },
                expanded: d.expanded,
                children: Array.isArray(d.children)
                  ? d.children.map((c) => ({
                      ...c,
                      data: c.data ? { ...c.data } : c.data,
                      children: Array.isArray(c.children)
                        ? c.children.map((gc) => ({
                            ...gc,
                            data: gc.data ? { ...gc.data } : gc.data,
                          }))
                        : c.children,
                    }))
                  : d.children,
              });

              this.summaryList.push({
                data: { ...d.data },
                expanded: d.expanded,
                // require: d.isDefaultQuantity
              });
            } else {
              if (d.type === 0) {
                this.deviceUsageTotal.quantity = d.quantity;
                this.deviceUsageTotal.last_quantity = d.last_quantity;
                this.deviceUsageTotal.name = d.name;
              } else {
                this.summaryTotal.name = 'PPCPROMONTHLY TOTAL';
                this.summaryTotal.unitprice = this.dialogDocInput.UnitPrice;

                if (this.dialogDocInput.PaymentType === 0) {
                  this.summaryTotal.quantity = this.dialogDocInput.Quantity;
                  this.summaryTotal.amount = this.dialogDocInput.Quantity * this.dialogDocInput.UnitPrice;
                } else {
                  this.summaryTotal.quantity = d.quantity;
                  this.summaryTotal.amount = d.quantity * this.dialogDocInput.UnitPrice;
                }
              }
            }
          });
          this.GeneratePeriodDate();
          // this.dialogDocInput.UnitPrice = this.getMspDeviceUsageParam.UnitPrice !== undefined && this.getMspDeviceUsageParam.UnitPrice !== 0 ? this.getMspDeviceUsageParam.UnitPrice : 1;
          this.show_Doc_Info = {
            BillingInfo: true,
            Summary: true,
            DeviceUsage: this.dialogDocInput.PaymentType === this.ChargeType.Monthly
          };
          this.PreviewSuccess = true;
          if (!this.once_preview) {
            this.once_preview = true // Edit進入的時候先點及Preview一次
            this.preview()
          }
        }
      }
      this.ngxService.stop();
    });

    this.store.select(fromStore.getMspRegionPayment).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      // this.ngxService.start();
      if ((res !== undefined && res !== null)) {
        if (res.payment_list.length > 0) {
          this.companyOptions = [];
          this.companyOptions.push({ label: 'All', value: true});
          
          const setting = this.GetPaymentSettingByRegionId(res.payment_list, regionId);
          if (setting) {
            this.getMspDeviceUsageParam = {
              ...this.getMspDeviceUsageParam,
              RegionId: regionId,
              UnitPrice: setting.UnitPrice,
            };
            this.dialogDocInput.UnitPrice = (this.dialogDocInput.Type === 'Add') ? (setting.UnitPrice !== undefined && setting.UnitPrice !== 0 ? setting.UnitPrice : 1) : this.dialogDocInput.UnitPrice;
            this.docUnitPriceStatsh = setting.UnitPrice !== undefined && setting.UnitPrice !== 0 ? setting.UnitPrice : 1;
            this.docDetailInfo.MinCharge = setting.MinCharge;
            this.isDistributor = setting.IsDistributor;
            // this.docType = setting.DocType;
            this.companyOptions.push({ label: setting.Company, value: false});
            this.dialogDocInput.EmailInfo = setting.EmailInfo;
            this.dialogDocInput.IsDistributorAll = setting.IsDistributor;
            this.dialogDocInput.DocDay = setting.DocDay;
            this.docDetailInfo.Company = setting.CompanyName;
            this.docDetailInfo.RegionName = setting.Company;
            this.getDefaultDate();
          }
        }
      }
    });

    // Get Doc List
    this.store.select(fromStore.getMspPaymentDocumentList).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined) {
        if ( res.doc_List.length > 0) {
          this.docList_dic = {
            op_dic: [],
            invoice_dic: [],
          };
          [...res.doc_List].sort(function (a: any, b: any) {
            return b.DocId - a.DocId;
          }).map((item) => {
            // 20240419
            const splitdate = item.DocDate.split('-');
            // 202404
            if (item.DocType === 0) {
              if (this.docList_dic.op_dic[splitdate[0] + splitdate[1]] !== undefined) {
                this.docList_dic.op_dic[splitdate[0] + splitdate[1]].push(item);
              } else {
                this.docList_dic.op_dic[splitdate[0] + splitdate[1]] = [];
                this.docList_dic.op_dic[splitdate[0] + splitdate[1]].push(item);
              }
            } else {
              if (this.docList_dic.invoice_dic[splitdate[0] + splitdate[1]] !== undefined) {
                this.docList_dic.invoice_dic[splitdate[0] + splitdate[1]].push(item);
              } else {
                this.docList_dic.invoice_dic[splitdate[0] + splitdate[1]] = [];
                this.docList_dic.invoice_dic[splitdate[0] + splitdate[1]].push(item);
              }
            }

          });
        }
      }
    });

    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.type === updateInfoType.GenerateMspPaymentDocument) {
        this.messageService.clear();
        if (!res.isLoading && res.isLoaded && res.isSaved) {
          this.backClicked();
          this.messageService.add({ severity: 'success', summary: 'Generate Success' });
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          this.messageService.add({ severity: 'error', summary: 'Generate Fail' });
        }
        this.resetUpdateInfoState();
        this.ngxService.stop();
      }
      if (res.type === updateInfoType.UpdateMspPaymentDocument) {
        this.messageService.clear();
        if (!res.isLoading && res.isLoaded && res.isSaved) {
          this.backClicked();
          this.messageService.add({ severity: 'success', summary: 'Update Success' });
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          this.messageService.add({ severity: 'error', summary: 'Update Fail' });
        }
        this.resetUpdateInfoState();
        this.ngxService.stop();
      }
    });

    this.getBillingStatement();
  }

  ngOnInit() {
    this.deviceUsageList = [];
    this.show_Doc_Info = {
      BillingInfo: false,
      Summary: false,
      DeviceUsage: false
    };
    this.generateYears();
  }

  backClicked() {
    this._location.back();
  }

  getDefaultDate() {
    this.generateMonths(true);
  }

  getBillingCycleRange(targetDate, DocDay) {
    const baseDateForCycle = new Date(targetDate);
    if (targetDate.getDate() < DocDay) {
      baseDateForCycle.setMonth(baseDateForCycle.getMonth() - 1);
    }
    
    const startYear = baseDateForCycle.getFullYear();
    const startMonth = baseDateForCycle.getMonth(); // 0-11
    
    const daysInStartMonth = new Date(startYear, startMonth + 1, 0).getDate();
    const startDay = Math.min(DocDay, daysInStartMonth);
    const startDate = new Date(startYear, startMonth, startDay);

    let nextCycleYear = startYear;
    let nextCycleMonth = startMonth + 1;
    if (nextCycleMonth > 11) {
      nextCycleMonth = 0;
      nextCycleYear += 1;
    }
    const daysInNextCycleMonth = new Date(nextCycleYear, nextCycleMonth + 1, 0).getDate();
    const nextCycleStartDay = Math.min(DocDay, daysInNextCycleMonth);
    const nextCycleStartDate = new Date(nextCycleYear, nextCycleMonth, nextCycleStartDay);
    
    const endDate = new Date(nextCycleStartDate);
    endDate.setDate(endDate.getDate() - 1);

    // 我們不需要在這裡設定時間，因為我們只關心年月日
    return { startDate, endDate };
  }

  getLastSelectableMonth(today) {
    const currentCycle = this.getBillingCycleRange(today, this.dialogDocInput.DocDay);
    const dateInPreviousCycle = new Date(currentCycle.startDate);
    dateInPreviousCycle.setDate(dateInPreviousCycle.getDate() - 1);
    const previousCycle = this.getBillingCycleRange(dateInPreviousCycle, this.dialogDocInput.DocDay);
    const representativeDate = previousCycle.startDate;
    return {
      year: representativeDate.getFullYear(),
      month: representativeDate.getMonth() + 1
    };
  }

  generateMonths(isInit) {
    const today = new Date();
    this.monthOptions = [];
    const lastSelectable = this.getLastSelectableMonth(today);
    this.dialogDocInput.Month = this.dialogDocInput.Type === 'Edit' ?
    (isInit ? this.dialogDocInput.Month : 0) :
    (isInit ? ((this.dialogDocInput.Year === lastSelectable.year) ? lastSelectable.month : 0) : 0);
    if (lastSelectable.year < this.dialogDocInput.Year) {
        for (let i = 1; i <= 12; i++) {
            this.monthOptions.push({ label: monthMap[i], value: i, disabled: true });
        }
        return;
    }

    if (lastSelectable.year > this.dialogDocInput.Year) {
        for (let i = 1; i <= 12; i++) {
            this.monthOptions.push({ label: monthMap[i], value: i, disabled: false });
        }
        return;
    }

    for (let i = 1; i <= 12; i++) {
      const currentMonth = i;
      const isDisabled = currentMonth > lastSelectable.month;
      
      this.monthOptions.push({
        label: monthMap[currentMonth],
        value: currentMonth,
        disabled: isDisabled
      });
    }
  }
  
  GeneratePeriodDate() {
    const startMonthIndex = this.dialogDocInput.Month - 1;
    const daysInStartMonth = new Date(this.dialogDocInput.Year, startMonthIndex + 1, 0).getDate();
    const startDay = Math.min(this.dialogDocInput.DocDay, daysInStartMonth);
    const startDate = new Date(this.dialogDocInput.Year, startMonthIndex, startDay);
    let nextCycleYear = this.dialogDocInput.Year;
    let nextCycleMonth = startMonthIndex + 1;
    if (nextCycleMonth > 11) {
      nextCycleMonth = 0;
      nextCycleYear++;
    }
    const daysInNextCycleMonth = new Date(nextCycleYear, nextCycleMonth + 1, 0).getDate();
    const nextCycleStartDay = Math.min(this.dialogDocInput.DocDay, daysInNextCycleMonth);
    const nextCycleStartDate = new Date(nextCycleYear, nextCycleMonth, nextCycleStartDay);
    const endDate = new Date(nextCycleStartDate);
    endDate.setDate(nextCycleStartDate.getDate() - 1);
    this.docDetailInfo.Period = `${this.formatDate(startDate)} - ${this.formatDate(endDate)}`;
  }

  generateYears() {
    const today = new Date();
    if (this.dialogDocInput.Type === 'Add') {
      this.dialogDocInput.Year = today.getFullYear();
    }
    for (let i = 2023; i <= today.getFullYear(); i++) {
      this.yearOptions.push({ label: i.toString(), value: i });
    }
  }

  changeYears(event) {
    this.generateMonths(false);
  }

  showComfirmDialog(type) {
    const month = this.dialogDocInput.Month;
    const year = this.dialogDocInput.Year;
    let new_month = month.toString().padStart(2, '0');

    // const dateStr = `${year}${new_month}01`;
    const checkYearMonth = `${year}${new_month}`;
    if (this.docType === 0) {
      if (this.docList_dic.op_dic.length === 0 || this.docList_dic.op_dic[checkYearMonth] === undefined) {
        this.docMonthYearIsExist = false;
      } else {
        this.dialogDocInput_No = this.docList_dic.op_dic[checkYearMonth][0].DocNo;
        this.docMonthYearIsExist = true;
      }
    } else {
      if (this.docList_dic.invoice_dic.length === 0 || this.docList_dic.invoice_dic[checkYearMonth] === undefined) {
        this.docMonthYearIsExist = false;
      } else {
        this.dialogDocInput_No = this.docList_dic.invoice_dic[checkYearMonth][0].DocNo;
        this.docMonthYearIsExist = true;
      }
    }

    if (type === ComfirmGenerateDocumentManuallyType.ComfirmAndSend) {
      this.dialogVisibility.confirm = true;
      this.dialogVisibility.sendPDF = true;
    } else {
      this.dialogVisibility.confirm = true;
      this.dialogVisibility.sendPDF = false;
    }
  }

  saveDoc(mailflag: boolean) {
    this.dialogVisibility.confirm = false;
    this.ngxService.start();
    // this._location.back();
    const today = new Date();
    const year = (this.dialogDocInput.PaymentType === 0) ? today.getFullYear().toString() : this.dialogDocInput.Year.toString();
    const month = (this.dialogDocInput.PaymentType === 0) ? (today.getMonth() + 1).toString().padStart(2, '0') : this.dialogDocInput.Month.toString().padStart(2, '0');
    const date = (this.dialogDocInput.PaymentType === 0) ? today.getDate().toString().padStart(2, '0') : this.dialogDocInput.DocDay.toString().padStart(2, '0');
    const dateStr = `${year}-${month}-${date}`;
    this.getMspDeviceUsageParam = {
      ...this.getMspDeviceUsageParam,
      UnitPrice: this.dialogDocInput.UnitPrice !== undefined && this.dialogDocInput.UnitPrice !== 0 ? this.dialogDocInput.UnitPrice : 1,
    };
    if (this.dialogDocInput.Type === 'Add') {
      const param = {
        otp: '',
        RegionId: this.getMspDeviceUsageParam.RegionId,
        DocDate: dateStr,
        DocNo: this.dialogDocInput.DocNo,
        UnitPrice: this.dialogDocInput.UnitPrice,
        // IsMail: mailflag,
        // IsDistributorAll: this.dialogDocInput.IsDistributorAll,
        IsFree: this.dialogDocInput.IsFree,
        PaymentType: this.dialogDocInput.PaymentType,
        PaymentUsage: (this.dialogDocInput.PaymentType === 0) ? this.dialogDocInput.Quantity : null
      };
      this.store.dispatch(new fromFeature.GenerateMspPaymentDocument(param));
    }
    if (this.dialogDocInput.Type === 'Edit') {
      const param = {
        otp: '',
        DocId: this.dialogDocInput.DocId,
        DocStatus: this.dialogDocInput.DocStatus,
        DocNo: this.dialogDocInput.DocNo,
        DocDate: this.dialogDocInputDisabled.Date ? null: dateStr,
        UnitPrice: this.dialogDocInputDisabled.UnitPrice ? null : this.dialogDocInput.UnitPrice,
        IsFree: this.dialogDocInput.IsFree,
        PaymentUsage: this.dialogDocInputDisabled.Quantity ? null :  ((this.dialogDocInput.PaymentType === 0) ? this.dialogDocInput.Quantity : null)
      };
      this.store.dispatch(new fromFeature.UpdateMspPaymentDocument(param));
    }
  }

  preview() {
    this.ngxService.start();
    this.show_Doc_Info = {
      BillingInfo: false,
      Summary: false,
      DeviceUsage: false
    };
    this.getMspDeviceUsageParam = {
      ...this.getMspDeviceUsageParam,
      UnitPrice: this.dialogDocInput.UnitPrice,
      ...(this.dialogDocInput.PaymentType === 0
        ? { Quantity: this.dialogDocInput.Quantity }
        : {}),
    };

    const today = new Date();
    const year = (this.dialogDocInput.PaymentType === 0) ? today.getFullYear().toString() : this.dialogDocInput.Year.toString();
    const month = (this.dialogDocInput.PaymentType === 0) ? (today.getMonth() + 1).toString().padStart(2, '0') : this.dialogDocInput.Month.toString().padStart(2, '0');
    const date = (this.dialogDocInput.PaymentType === 0) ? today.getDate().toString().padStart(2, '0') : this.dialogDocInput.DocDay.toString().padStart(2, '0');
    // 前一月份的1號
    const dateStr = `${year}-${month}-01`;
    
    if (this.dialogDocInput.PaymentType === PaymentTypeIndex.Prepaid) {
      this.show_Doc_Info = {
        BillingInfo: true,
        Summary: true,
        DeviceUsage: false
      };
      this.PreviewSuccess = true;
      this.summaryList = [{
        data: {
          name: 'PPCRPOMONTHLY',
          unitprice: this.dialogDocInput.UnitPrice,
          total_quantity: this.dialogDocInput.Quantity,
          total_amount: this.dialogDocInput.Quantity * this.dialogDocInput.UnitPrice,
          isDefaultQuantity: false
        }
      }];
      this.summaryTotal.name = 'PPCPROMONTHLY TOTAL';
      this.summaryTotal.amount = this.dialogDocInput.Quantity * this.dialogDocInput.UnitPrice;
      this.ngxService.stop();
    }
    if (this.dialogDocInput.PaymentType === PaymentTypeIndex.Monthly) {

      // this.datePickStart = new Date(dateStr);
      this.getMspDeviceUsageParam = {
        ...this.getMspDeviceUsageParam,
        UsageDate: dateStr,
        IsDistributorAll: this.dialogDocInput.IsDistributorAll,
      };
      this.getMspDocParam = {
        ...this.getMspDocParam,
        RegionId: this.getMspDeviceUsageParam.RegionId,
      };
      this.store.dispatch(new fromFeature.ReadMspDeviceUsageList({ ...this.getMspDeviceUsageParam }));
      this.store.dispatch(new fromFeature.ReadMspPaymentDocumentList({ ...this.getMspDocParam }));
    }
  }

  replaceToFixed(e) {
    const inputElement = e.target;
    const value = inputElement.value;
    const regex = /^\d*\.?\d{0,2}$/;
    const isValid = regex.test(value);
    if (!isValid && value !== undefined) {
      const formattedValue = parseFloat(value).toFixed(2);
      this.dialogDocInput.UnitPrice = parseFloat(formattedValue);
    }
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

  isFreeOnChange(event) {
    // PrimeNG 20 Checkbox onChange 傳入 CheckboxChangeEvent，不是 boolean
    const checked = typeof event === 'boolean' ? event : !!event?.checked;
    this.dialogDocInput = {
      ...this.dialogDocInput,
      IsFree: checked,
      UnitPrice: checked ? 0 : this.docUnitPriceStatsh,
    };
    this.dialogDocInputDisabled = {
      ...this.dialogDocInputDisabled,
      UnitPrice: checked,
    };
  }

  changeSetting() {
    this.PreviewSuccess = false;
    this.show_Doc_Info = {
      BillingInfo: false,
      Summary: false,
      DeviceUsage: false
    };
  }

  getBillingStatement() {
    if (this.regionService.GetBillingStatement) {
      const billingStatement = JSON.parse(this.regionService.GetBillingStatement);
      this.dialogDocInput.Type = 'Edit';
      this.dialogDocInput.DocId = billingStatement.DocId;
      this.dialogDocInput.DocNo = billingStatement.DocNo;
      this.dialogDocInput.Quantity = billingStatement.PaymentUsage;
      this.dialogDocInput.PaymentType = billingStatement.PaymentType;
      this.dialogDocInput.DocStatus = billingStatement.DocStatus;
      this.dialogDocInput.UnitPrice = billingStatement.UnitPrice;
      this.dialogDocInput.Month = parseInt(billingStatement.Month, 10);
      this.dialogDocInput.Year = parseInt(billingStatement.Year, 10);
      this.dialogDocInput.IsFree = billingStatement.IsFree == 1 ? true : false;
      
      if (billingStatement.DocStatus === mspPaymentDocumentStatusNumber.Open) {
        this.dialogDocInputDisabled = {
          UnitPrice: true,
          Date: true,
          Month: true,
          Year: true,
          DocNo: false,
          PaymentType: true,
          Quantity: true,
          IsFree: true
        };
      } else {
        this.dialogDocInputDisabled = {
          UnitPrice: false,
          Date: false,
          Month: false,
          Year: false,
          DocNo: false,
          PaymentType: true,
          Quantity: false,
          IsFree: false
        };
      }
      if (this.dialogDocInput.IsFree) {
        this.dialogDocInput.UnitPrice = 0;
        this.dialogDocInputDisabled.UnitPrice = true;
      }
    }
  }

  formatDate(date) {
    const year = date.getFullYear();
    // getMonth() 回傳 0-11，所以要加 1
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}/${month}/${day}`;
  }

  GetPaymentSettingByRegionId(PaymentSettingArray, regionId) {
    for (const paymentSetting of PaymentSettingArray) {
      if (paymentSetting.MspRegionId === regionId) {
        return paymentSetting;
      }
      if (Array.isArray(paymentSetting.Customers)) {
        const foundCustomer = paymentSetting.Customers.find(customer => customer.MspRegionId === regionId);
        if (foundCustomer) {
          return foundCustomer;
        }
      }
    }
    return null;
  }
}
